export interface DownloadFile {
  name: string;
  blob: Blob;
}
